import React from 'react';
import { CreditCard, DollarSign } from 'lucide-react';

const FeesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  if (!formData.includeFees) return null;

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <DollarSign className="w-5 h-5 mr-2 text-blue-500" />
        Комиссии и сборы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Начальная комиссия */}
        <div>
          <label htmlFor="initialFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Начальная комиссия
          </label>
          <input
            type="text"
            id="initialFee"
            name="initialFee"
            value={formData.initialFee}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.initialFee ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.initialFee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.initialFee}
            </p>
          )}
        </div>

        {/* Ежемесячная комиссия */}
        <div>
          <label htmlFor="monthlyFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ежемесячная комиссия
          </label>
          <div className="flex">
            <input
              type="text"
              id="monthlyFee"
              name="monthlyFee"
              value={formData.monthlyFee}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.monthlyFee ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
            <select
              name="monthlyFeeType"
              value={formData.monthlyFeeType}
              onChange={handleInputChange}
              className="form-select ml-2 w-1/3"
            >
              <option value="fixed">Фиксированная</option>
              <option value="percent">% от остатка</option>
            </select>
          </div>
          {errors.monthlyFee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.monthlyFee}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <CreditCard className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Важно знать о комиссиях
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Комиссии могут существенно влиять на общую стоимость кредита. 
              Фиксированная комиссия - это static платеж, а процентная взимается 
              от остатка долга и уменьшается со временем.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesSection;